import React from 'react';
import './WhatsAppButton.css';
import { envConfig } from '../../config/config';

const WhatsAppButton = () => {
  const openWhatsApp = () => {
    window.open(`https://wa.me/91${envConfig.NUMBER}`, '_blank');
  };

  return (
    <button className="whatsapp-float-btn" onClick={openWhatsApp} aria-label="Chat on WhatsApp">
      <svg
        viewBox="0 0 32 32"
        fill="currentColor"
        className="wa-icon"
      >
        <path d="M16.035 2a14 14 0 0 0-11.83 21.46L2 30l6.735-2.148A13.961 13.961 0 0 0 16.032 30a14 14 0 1 0 .003-28zm0 25.688a11.603 11.603 0 0 1-5.918-1.621l-.423-.25-4.4.141 1.433-4.29-.276-.438A11.644 11.644 0 0 1 4.312 16a11.685 11.685 0 0 1 11.72-11.688A11.704 11.704 0 0 1 27.75 16 11.674 11.674 0 0 1 16.035 27.688zm6.417-8.773c-.352-.176-2.083-1.028-2.406-1.146-.323-.117-.557-.176-.791.176-.235.352-.91 1.146-1.115 1.38-.205.234-.41.263-.762.087-.352-.176-1.488-.549-2.836-1.751-1.048-.934-1.755-2.089-1.96-2.441-.205-.352-.022-.542.154-.717.158-.158.352-.41.528-.616.176-.205.234-.352.352-.586.117-.234.058-.439-.03-.615-.088-.176-.791-1.91-1.085-2.613-.287-.686-.578-.593-.791-.604-.158-.009-.41-.009-.645-.009a1.233 1.233 0 0 0-.88.41c-.307.323-1.173 1.144-1.173 2.79 0 1.646 1.202 3.238 1.368 3.461.166.223 2.361 3.606 5.719 5.056.8.345 1.424.551 1.91.705.803.255 1.535.219 2.113.133.644-.096 1.97-.806 2.247-1.583.277-.777.277-1.442.195-1.583-.082-.141-.316-.223-.668-.4zm0 0" />
      </svg>
    </button>
  );
};

export default WhatsAppButton;
